import validationRules from 'coreUtils/validationRules';

import {IPasswordMessages, IPasswordValidation, PasswordValidationConfig} from './IPasswordField';
import defaultMessages from './messages';

export const createPasswordValidation = (config: PasswordValidationConfig, overrideMessages?: IPasswordMessages) => {
	const passwordValidation: IPasswordValidation[] = [];

	const messages = {
		passwordErrorLetters: overrideMessages?.passwordErrorLetters || defaultMessages.passwordErrorLetters,
		passwordErrorNumbers: overrideMessages?.passwordErrorNumbers || defaultMessages.passwordErrorNumbers,
		passwordErrorMixedLetters:
			overrideMessages?.passwordErrorMixedLetters || defaultMessages.passwordErrorMixedLetters,
		passwordErrorLength: overrideMessages?.passwordErrorLength || defaultMessages.passwordErrorLength,
		passwordSpecialCharsMinLength:
			overrideMessages?.passwordSpecialCharsMinLength || defaultMessages.passwordSpecialCharsMinLength,
	};

	if (config.forceLetters) {
		passwordValidation.push({
			rule: validationRules.hasLetters,
			errorMessage: messages.passwordErrorLetters,
		});
	}

	if (config.forceNumbers) {
		passwordValidation.push({
			rule: validationRules.hasNumbers,
			errorMessage: messages.passwordErrorNumbers,
		});
	}

	if (config.forceMixedCase) {
		passwordValidation.push({
			rule: validationRules.hasMixedLetters,
			errorMessage: messages.passwordErrorMixedLetters,
		});
	}

	passwordValidation.push({
		rule: validationRules.hasCorrectLength(config.minLength, config.maxLength),
		errorMessage: messages.passwordErrorLength,
	});

	passwordValidation.push({
		rule: validationRules.hasCorrectSpecialCharsLength(config.minSpecialChars, null),
		errorMessage: messages.passwordSpecialCharsMinLength,
	});

	return passwordValidation;
};
